import { PREFERENCES_ACTION, PREFERENCES_PATH } from 'modules/training/modules/preferences/constants'
import setIdReduxAction from 'modules/redux/actions/set-id'

function updateCurrentPreferencesAction (instance) {
  return setIdReduxAction({
    type: instance
      ? PREFERENCES_ACTION.UPDATE_CURRENT
      : PREFERENCES_ACTION.RESET_CURRENT,
    payload: {
      path: PREFERENCES_PATH.CURRENT,
      instance
    }
  })
}

export default updateCurrentPreferencesAction
